import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { FaqsComponent } from "./faqs.component";

const routes: Routes = [
  {
    path: '',
    data: {
      title: 'FAQs'
    },
    children: [
      {
        path: '',
        component: FaqsComponent,
        data: {
          title: 'Home'
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FaqsRoutingModule { }
